import React, { FC } from "react";
import { Form } from "react-bootstrap";
import CustomSelect from "../../../../components/form/CustomSelect";
import InputMask from "react-input-mask";
import { OptionType } from "../../../../types/CommonType";
import { TreatmentModel } from "../../../../models/TreatmentModel";
import { TreatmentMedicationType } from "../../../../types/TreatmentType";
import clsx from "clsx";

interface TreatmentMedicationRowProps {
    item: TreatmentMedicationType;
    index: number;
    type: string;
    prescription: boolean;
    readOnly: boolean;
    data: TreatmentMedicationType[];
    setData: React.Dispatch<React.SetStateAction<TreatmentMedicationType[]>>;
    updatePrint: (index: number, print: boolean) => void;
    onEditClick?: (index: number) => void;
}

const TreatmentMedicationRow: FC<TreatmentMedicationRowProps> = ({
    item,
    index,
    type,
    prescription,
    readOnly=true,
    data,
    setData,
    updatePrint,
    onEditClick
}) => {
    return (
        <tr key={item.id}>
            <td>
                <Form.Group className="mb-3" controlId="name">
                    <CustomSelect
                        options={TreatmentModel()
                            .getMedicationsOptions()
                            .filter((o) => o.type === type)
                            .map((o) => {
                                return { ...o, label: `${o.label} (${o.unit})` };
                            })}
                        key={`medication-${item.medication}`}
                        name={`medication-${item.medication}`}
                        onChange={(o: OptionType) => {
                            data[index].medication = o.value;
                            setData([...data]);
                        }}
                        placeholder="Selecione..."
                        value={item.medication}
                        isSearchable={true}
                        disabled={prescription || readOnly}
                        isTouched={true}
                        isValid={data[index].medication !== ""}
                    />
                </Form.Group>
            </td>
            <td>
                <Form.Group className="mb-3" controlId="name">
                    <Form.Control
                        type="number"
                        value={item.dosage}
                        onChange={(e) => {
                            data[index].dosage = e.target.value;
                            setData([...data]);
                        }}
                        disabled={prescription || readOnly}
                        min={0}
                        isInvalid={data[index].dosage === ""}
                    />
                </Form.Group>
            </td>
            <td>
                <Form.Group className="mb-3" controlId="name">
                    <CustomSelect
                        options={TreatmentModel().getPosologyOptions()}
                        name={`posology`}
                        onChange={(o: OptionType) => {
                            data[index].posology = o.value;
                            setData([...data]);                            
                        }}
                        placeholder="Selecione..."
                        value={item.posology}
                        disabled={prescription || readOnly}
                        isTouched={true}
                        isValid={data[index].posology !== ""}
                    />
                </Form.Group>
            </td>
            <td>
                <Form.Group className="mb-3" controlId="name">
                    <Form.Control
                        type="date"
                        value={item.date_start}
                        onChange={(e) => {
                            data[index].date_start = e.target.value;
                            setData([...data]);

                            if(data[index].posology === "UNI") {
                                data[index].date_end = e.target.value;
                            }
                        }}
                        disabled={prescription || readOnly}
                        isInvalid={data[index].date_start === ""}
                    />
                </Form.Group>
            </td>
            <td>
                <Form.Group className="mb-3" controlId="name">
                    <Form.Control
                        type="date"
                        value={item.date_end}
                        onChange={(e) => {
                            data[index].date_end = e.target.value;
                            setData([...data]);
                        }}
                        disabled={prescription || data[index].posology === "UNI" || readOnly}
                        isInvalid={data[index].date_end === ""}
                        min={item.date_start ? item.date_start : undefined}
                    />
                </Form.Group>
            </td>
            <td>
                <Form.Group className="mb-3" controlId="name">
                    <InputMask
                        value={item.start_time}
                        onChange={(e) => {
                            data[index].start_time = e.target.value;
                            setData([...data]);
                        }}
                        name={"start_time"}
                        type="text"
                        mask="99:99"
                        className={clsx("form-control", {
                            "is-invalid": data[index].start_time === "",
                        })}
                        disabled={prescription || readOnly}
                    />
                </Form.Group>
            </td>
            {!prescription && (
                <td>
                    <div>
                        {onEditClick && (
                            <a
                                href="#"
                                className="btn btn-light me-2"
                                onClick={(e) => {
                                    onEditClick(index);
                                }}
                            >
                                <i className="bi bi-pencil"></i>
                            </a>
                        )}
                        <a
                            href="#"
                            className="btn btn-light"
                            onClick={(e) => {
                                data.splice(index, 1);
                                setData([...data]);
                            }}
                        >
                            <i className="bi bi-trash"></i>
                        </a>
                        
                    </div>
                </td>
            )}
            {prescription && (
                <td>
                    <Form.Check
                        type="checkbox"
                        onChange={() => {
                            updatePrint(index, !item.print);
                        }}
                        checked={item.print}
                    ></Form.Check>
                </td>
            )}
        </tr>
    );
};

export default TreatmentMedicationRow;